import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "components/Pagination";
import { ROUTES } from "shared/constants/routes";
import { fetchAllSubmittedDtfOrders } from "actions/dtfOrders";
import AdminOrderCard from "./AdminOrderCard";
import OrderDetailDialog from "./OrderDetailDialog";
import {
  PageHeader,
  PageTitle,
  PageSubtitle,
  EmptyState,
  EmptyTitle,
  EmptyText,
  LoadingState,
  LoadingDots,
} from "styles/pages/dtf-transfers/orders";
import { Container, PaginationWrapper } from "styles/pages/warehouse";
import {
  OrderGrid,
  OrdersSection,
  SectionHeading,
} from "styles/pages/admin-dtf-orders";

const TAKE = 20;

const AdminDtfOrders = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.auth?.profile?.token);

  const [orders, setOrders] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    const loadOrders = async () => {
      setLoading(true);
      const skip = (currentPage - 1) * TAKE;
      const response = await dispatch(
        fetchAllSubmittedDtfOrders({ skip, take: TAKE }, token),
      );

      if (response?.error) {
        setOrders([]);
        setTotalCount(0);
      } else {
        setOrders(response.orders ?? []);
        setTotalCount(response.totalCount ?? 0);
      }

      setLoading(false);
    };

    loadOrders();
  }, [dispatch, token, currentPage]);

  return (
    <Container>
      <PageHeader>
        <PageTitle>{ROUTES.ADMIN_DTF_ORDERS.TITLE}</PageTitle>
        <PageSubtitle>
          VIEW ALL SUBMITTED DTF TRANSFER ORDERS
          {totalCount > 0 ? ` · ${totalCount} total` : ""}
        </PageSubtitle>
      </PageHeader>

      {loading ? (
        <LoadingState>
          <LoadingDots aria-hidden>
            <span />
            <span />
            <span />
          </LoadingDots>
          <EmptyTitle>Loading orders...</EmptyTitle>
        </LoadingState>
      ) : orders.length === 0 ? (
        <EmptyState>
          <EmptyTitle>No DTF orders found</EmptyTitle>
          <EmptyText>Submitted DTF transfer orders will appear here.</EmptyText>
        </EmptyState>
      ) : (
        <OrdersSection>
          <SectionHeading>All DTF Orders ({totalCount})</SectionHeading>
          <OrderGrid>
            {orders.map((order, index) => (
              <AdminOrderCard
                key={order?._id ?? order?.orderId ?? order?.id ?? index}
                order={order}
                onClick={setSelectedOrder}
              />
            ))}
          </OrderGrid>

          <PaginationWrapper>
            <Pagination
              totalCount={totalCount}
              take={TAKE}
              page={currentPage}
              onChange={(_, page) => setCurrentPage(page)}
            />
          </PaginationWrapper>
        </OrdersSection>
      )}

      <OrderDetailDialog
        open={!!selectedOrder}
        order={selectedOrder}
        onClose={() => setSelectedOrder(null)}
      />
    </Container>
  );
};

export default AdminDtfOrders;
